/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Freegamebadge2Inputs */

const id_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Gratis`)
};

const ms_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan Percuma`)
};

const da_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Spil`)
};

const de_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloses Spiel`)
};

const en_us2_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Game`)
};

const es_es2_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juego gratis`)
};

const es_mx2_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juego gratis`)
};

const fil_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libreng Laro`)
};

const fr_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeu gratuit`)
};

const it_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioco Gratuito`)
};

const hu_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingyenes játék`)
};

const nl_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Game`)
};

const no_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis spill`)
};

const pl_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowa gra`)
};

const pt_br2_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogo grátis`)
};

const pt_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogo grátis`)
};

const ro_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joc gratuit`)
};

const fi_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmainen peli`)
};

const sv_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis spel`)
};

const vi_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game miễn phí`)
};

const tr_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz Oyun`)
};

const cs_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hra zdarma`)
};

const bg_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безплатна игра`)
};

const ru_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатная игра`)
};

const uk_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безкоштовна гра`)
};

const ar_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لعبة مجانية`)
};

const hi_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुफ़्त गेम`)
};

const th_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมฟรี`)
};

const ja_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料ゲーム`)
};

const zh_cn2_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费游戏`)
};

const zh_hant1_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費遊戲`)
};

const ko_misc_posts_freegamebadge2 = /** @type {(inputs: Misc_Posts_Freegamebadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 게임`)
};

/**
* | output |
* | --- |
* | "Free Game" |
*
* @param {Misc_Posts_Freegamebadge2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_freegamebadge2 = /** @type {((inputs?: Misc_Posts_Freegamebadge2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Freegamebadge2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_freegamebadge2(inputs)
	if (locale === "ms") return ms_misc_posts_freegamebadge2(inputs)
	if (locale === "da") return da_misc_posts_freegamebadge2(inputs)
	if (locale === "de") return de_misc_posts_freegamebadge2(inputs)
	if (locale === "en-US") return en_us2_misc_posts_freegamebadge2(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_freegamebadge2(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_freegamebadge2(inputs)
	if (locale === "fil") return fil_misc_posts_freegamebadge2(inputs)
	if (locale === "fr") return fr_misc_posts_freegamebadge2(inputs)
	if (locale === "it") return it_misc_posts_freegamebadge2(inputs)
	if (locale === "hu") return hu_misc_posts_freegamebadge2(inputs)
	if (locale === "nl") return nl_misc_posts_freegamebadge2(inputs)
	if (locale === "no") return no_misc_posts_freegamebadge2(inputs)
	if (locale === "pl") return pl_misc_posts_freegamebadge2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_freegamebadge2(inputs)
	if (locale === "pt") return pt_misc_posts_freegamebadge2(inputs)
	if (locale === "ro") return ro_misc_posts_freegamebadge2(inputs)
	if (locale === "fi") return fi_misc_posts_freegamebadge2(inputs)
	if (locale === "sv") return sv_misc_posts_freegamebadge2(inputs)
	if (locale === "vi") return vi_misc_posts_freegamebadge2(inputs)
	if (locale === "tr") return tr_misc_posts_freegamebadge2(inputs)
	if (locale === "cs") return cs_misc_posts_freegamebadge2(inputs)
	if (locale === "bg") return bg_misc_posts_freegamebadge2(inputs)
	if (locale === "ru") return ru_misc_posts_freegamebadge2(inputs)
	if (locale === "uk") return uk_misc_posts_freegamebadge2(inputs)
	if (locale === "ar") return ar_misc_posts_freegamebadge2(inputs)
	if (locale === "hi") return hi_misc_posts_freegamebadge2(inputs)
	if (locale === "th") return th_misc_posts_freegamebadge2(inputs)
	if (locale === "ja") return ja_misc_posts_freegamebadge2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_freegamebadge2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_freegamebadge2(inputs)
	return ko_misc_posts_freegamebadge2(inputs)
});
export { misc_posts_freegamebadge2 as "misc.posts.freeGameBadge" }